const {
  SPELL_BANISHMENT,
  SPELL_BESTOW_CURSE,
  SPELL_CALM_EMOTIONS,
  SPELL_CLAIRVOYANCE,
  SPELL_COMMAND,
  SPELL_CURE_WOUNDS,
  SPELL_FLAME_STRIKE,
  SPELL_FREEDOM_OF_MOVEMENT,
  SPELL_GEAS,
  SPELL_HOLD_PERSON,
  SPELL_MENDING,
  SPELL_SACRED_FLAME,
  SPELL_SHIELD_OF_FAITH,
  SPELL_THAUMATURGY,
  SPELL_TRUE_SEEING,
  SPELL_WISH,
} = require('./../../../../spellIdList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CREATURE_TYPE_MONSTROSITY,
  CREATURE_TYPE_NAGA,
} = require('./../../../../creatureTypeIdList')
const {
  LANG_CELESTIAL,
  LANG_COMMON,
} = require('./../../../../languageIdList')
const {
  DAMAGE_PIERCING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  CONDITION_CHARMED,
  CONDITION_POISONED,
} = require('./../../../../conditionList')
const {
  ATTACK_MELEE_WEAPON,
  ATTACK_RANGE_WEAPON,
} = require('./../../../../attackTypeList')
const {ALIGNMENT_LG} = require('./../../../../aligmentList')
const {ARMOR_TYPE_NATURAL} = require('./../../../../armorTypeList')
const {CAST_VERBAL} = require('./../../../../castComponentList')
const {CR_10} = require('./../../../../crList')
const {CREATURE_GUARDIAN_NAGA} = require('./../../../../creatureIdList')
const {GENDER_FEMALE} = require('./../../../../genderList')
const {nagaDescription} = require('./../../../../textCommonParts')
const {PC_CLASS_CLERIC} = require('./../../../../pcClassIdList')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_LARGE} = require('./../../../../sizeList')
const {SOURCE_MM} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')
const {TARGET_CREATURE} = require('./../../../../targetList')

module.exports = {
  name: 'Охранная нага',
  nameEn: 'Guardian Naga',
  id: CREATURE_GUARDIAN_NAGA,
  description: [
    `Мудрые и добрые наги стражи охраняют священные места и предметы с магической силой от попадания в злые руки. В своих потайных убежищах они исследуют заклинания и вынашивают запутанные планы, чтобы сорвать злые замыслы врагов.

Охранная нага не ищет насилия, предупреждая нарушителей, а не атакуя. Только если противник упорно атакует нагу, она бросается на врага с заклинаниями и ядовитой слюной.`,
    nagaDescription,
  ],
  sizeType: SIZE_LARGE,
  creatureTypeIdList: [
    CREATURE_TYPE_MONSTROSITY,
    CREATURE_TYPE_NAGA,
  ],
  alignmentId: ALIGNMENT_LG,
  source: {
    id: SOURCE_MM,
    page: 219,
  },
  armor: {
    ac: 18,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 15,
  },
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 19,
    [PARAM_DEX]: 18,
    [PARAM_CON]: 16,
    [PARAM_INT]: 16,
    [PARAM_WIT]: 19,
    [PARAM_CHA]: 18,
  },
  saveThrowList: [
    PARAM_DEX,
    PARAM_CON,
    PARAM_INT,
    PARAM_WIT,
    PARAM_CHA,
  ],
  immunityList: [
    DAMAGE_POISON,
  ],
  immunityConditionList: [
    CONDITION_POISONED,
    CONDITION_CHARMED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    LANG_CELESTIAL,
    LANG_COMMON,
  ],
  cr: CR_10,
  featureList: [
    {
      name: 'Восстановление',
      description: `Если ★СУЩЕСТВО★ умирает, ★он★ возвращается к жизни через 1к6 дней и восстанавливает все хиты. Только заклинание [Исполнение желаний](SPELL:${SPELL_WISH}) может прекратить действие этой особенности.`,
    },
  ],
  spellCast: {
    spellCasterLevel: 11,
    spellCasterClass: PC_CLASS_CLERIC,
    componentOnly: CAST_VERBAL,
    spellIdList: [
      SPELL_BANISHMENT,
      SPELL_BESTOW_CURSE,
      SPELL_CALM_EMOTIONS,
      SPELL_CLAIRVOYANCE,
      SPELL_COMMAND,
      SPELL_CURE_WOUNDS,
      SPELL_FLAME_STRIKE,
      SPELL_FREEDOM_OF_MOVEMENT,
      SPELL_GEAS,
      SPELL_HOLD_PERSON,
      SPELL_MENDING,
      SPELL_SACRED_FLAME,
      SPELL_SHIELD_OF_FAITH,
      SPELL_THAUMATURGY,
      SPELL_TRUE_SEEING,
    ],
    slotCountList: [
      Infinity,
      4,
      3,
      3,
      3,
      2,
      1,
    ],
  },
  actionList: [
    {
      name: 'Укус',
      description: 'Цель должна пройти испытание Телосложения СЛ 15, получая урон ядом 45 (10к8) при провале, или половину этого урона при успехе.',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 8,
        range: 10,
        target: {
          count: 1,
          limit: {
            type: TARGET_CREATURE,
          },
        },
        hit: [
          {
            type: DAMAGE_PIERCING,
            diceCount: 1,
            diceType: 8,
            diceBonus: 4,
          },
        ],
      },
    },
    {
      name: 'Плевок ядом',
      description: `Цель должна пройти испытание Телосложения СЛ 15, получая урон ядом 45 (10к8) при провале, или половину этого урона при успехе.`,
      attack: {
        type: ATTACK_RANGE_WEAPON,
        bonus: 8,
        range: {
          normal: 15,
          max: 30,
        },
        target: {
          count: 1,
          limit: {
            type: TARGET_CREATURE,
          },
        },
      },
    },
  ],
  genderId: GENDER_FEMALE,
}
